import $http from '$http';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import {
    GetProvinces,
    GetCitys,
    GetAreas,
    GetAgentList,
    GetParmConfig, //寄送，支付接口
    GetProductClass,
    GetAgentConsigneeList,
    Consignee_Add,
    GetEmployList,
    ConsigneeSetDefault
} from '@api/commonApi.js';
export default {
    methods: {
        //获取列表
        getList() {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                pageIndex: this.pageIndex,
                pageSize: this.pageSize
            };

            //过滤没有查询的值传入服务器
            for (var i in this.query) {
                if (this.query.hasOwnProperty(i)) {
                    if (isCorrectVal(this.query[i])) {
                        // 去除空格trimAllSpace(str, is_global)  true 为去除所有空格
                        if (typeof this.query[i] == 'string') {
                            this.query[i] = util.trimAllSpace(this.query[i]);
                        }
                        params[i] = this.query[i]
                    }
                };
            }
            this.loading = true;
            $http.get("api/MeetOrder/GetPushOrderByPage", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.lists = Data;
                    this.totalSize = Cnt;
                });
            });
        },
        // 删除
        DelList(OrderId) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                OrderId: OrderId
            };
            this.loading = true;
            $http.get("api/MeetOrder/PushOrderDel", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: "删除成功",
                        type: 'success'
                    });
                    this.getList()
                });
            });
        },
    }
}


// WEBPACK FOOTER //
// ./src/pages/SchoolOrder/D55Order/services.js